import { GEO } from '../../../core/constants/geo';

export default class InitializeUserPreferences {
  constructor(userRepository) {
    this.userRepository = userRepository;
  }

  async execute(uid, initialData = {}) {
    try {
      const existingPreferences = await this.userRepository.getUserPreferences(uid);
      if (existingPreferences) {
        return existingPreferences; // Ne réinitialise pas si déjà défini
      }

      const defaultPreferences = {
        language: initialData.language || navigator.language?.split('-')[0] || 'fr',
        theme: 'system',
        contentLanguages: [initialData.language || navigator.language?.split('-')[0] || 'fr'],
        maxDistance: GEO.DEFAULT_RADIUS_KM,
        profileVisibility: 'followers',
        activityVisibility: 'followers',
        shareActivity: true,
        shareLocation: false,
        notifications: {
          email: true,
          push: true,
          sms: false,
          whatsapp: false
        },
        notificationTypes: {
          newMessage: true,
          newFollower: true,
          activityReminder: true,
          nearbyActivity: true
        },
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      };

      await this.userRepository.updateUserPreferences(uid, defaultPreferences);
      return defaultPreferences;
    } catch (error) {
      console.error('Error initializing user preferences:', error);
      throw error;
    }
  }
}